/**
 * AI 문서 아카이브 모듈 메뉴 (AR_)
 * hrMenuConfig 의 TOP/LEFT 에 병합한다.
 * 설계: docs/agent-plans/CM/20260923-AI문서아카이브-OCR전자서명계약인사문서-통합설계분석.md
 * 화면 컴포넌트가 아직 없으면 PageComponents 가 Placeholder 로 표시한다.
 */
export const ARCHIVE_TOP_MENUS = [
  { id: '1000', label: 'AI 문서 아카이브', icon: 'clipboard', iconSrc: null, menuNo: '1000', progId: 'AR' },
];

const leaf = (id, upper, label, screenId, menuType, url, comp) => ({
  id,
  label,
  menuNo: id,
  upperMenuId: upper,
  progId: screenId,
  screenId,
  menuType,
  url,
  componentPath: `pages/archive/${comp}`,
});

export const ARCHIVE_LEFT_MENUS = {
  '1000': [
    {
      id: '1000',
      label: 'AI 문서 아카이브',
      menuNo: '1000',
      upperMenuId: '0',
      url: 'dir',
      children: [
        leaf('1001', '1000', '아카이브 허브', 'AR_HUB', 'inquiry', '/archive/hub', 'ArchiveHub'),
        leaf('1010', '1000', '지출증빙 OCR', 'AR_OCR', 'crud', '/archive/ocr', 'ArchiveOcr'),
        leaf('1020', '1000', '계약정보 아카이브', 'AR_CONTRACT', 'crud', '/archive/contract', 'ArchiveContract'),
        leaf('1030', '1000', '인사정보 아카이브', 'AR_HR', 'crud', '/archive/hr', 'ArchiveHr'),
        leaf('1040', '1000', '전자서명', 'AR_SIGN', 'crud', '/archive/signature', 'ArchiveSignature'),
      ],
    },
  ],
};

/** ArchiveHub 카드 클릭 → openTab 에 그대로 넘길 수 있는 탭 데이터 — 위 leaf 정의와 1:1 대응 */
export const ARCHIVE_CARD_TABS = [
  {
    docCategory: 'OCR',
    id: '1010',
    label: '지출증빙 OCR',
    path: '/archive/ocr',
    component: 'AR_OCR',
    componentPath: 'pages/archive/ArchiveOcr',
    screenId: 'AR_OCR',
    menuPath: 'AI 문서 아카이브 > 지출증빙 OCR',
  },
  {
    docCategory: 'CONTRACT',
    id: '1020',
    label: '계약정보 아카이브',
    path: '/archive/contract',
    component: 'AR_CONTRACT',
    componentPath: 'pages/archive/ArchiveContract',
    screenId: 'AR_CONTRACT',
    menuPath: 'AI 문서 아카이브 > 계약정보 아카이브',
  },
  {
    docCategory: 'HR',
    id: '1030',
    label: '인사정보 아카이브',
    path: '/archive/hr',
    component: 'AR_HR',
    componentPath: 'pages/archive/ArchiveHr',
    screenId: 'AR_HR',
    menuPath: 'AI 문서 아카이브 > 인사정보 아카이브',
  },
  {
    docCategory: 'SIGNATURE',
    id: '1040',
    label: '전자서명',
    path: '/archive/signature',
    component: 'AR_SIGN',
    componentPath: 'pages/archive/ArchiveSignature',
    screenId: 'AR_SIGN',
    menuPath: 'AI 문서 아카이브 > 전자서명',
  },
];
